var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleDrive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 87.3 78"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0066da",
  d: "m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3L27.5 53H0c0 1.55.4 3.1 1.2 4.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00ac47",
  d: "M43.65 25 29.9 1.2c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44A9.06 9.06 0 0 0 0 53h27.5z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ea4335",
  d: "M73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75L86.1 57.5c.8-1.4 1.2-2.95 1.2-4.5H59.8l5.85 11.5z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#00832d",
  d: "M43.65 25 57.4 1.2C56.05.4 54.5 0 52.9 0H34.4c-1.6 0-3.15.45-4.5 1.2z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#2684fc",
  d: "M59.8 53H27.5L13.75 76.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffba00",
  d: "m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3L43.65 25 59.8 53h27.45c0-1.55-.4-3.1-1.2-4.5z"
})));
export default SvgGoogleDrive;